import React, {Component} from 'react';
import _ from 'lodash';
import {DataProviderFactory, registerProvider} from "./DataProviderFactory";
import CustomAuthProvider from "./CustomAuthProvider";

/**
 * Customize, import dashboard and about resources
 */
import dashboard from "./dashboard/dashboard";
//import CustomAppAboutResources from './about/CustomAppAboutResources';

/**
 * CUSTOMIZE Theme related
 */
import {createMuiTheme} from '@material-ui/core/styles';
import {orange800, green} from '@material-ui/core/colors';

/**
 * CUSTOMIZE - i18n related ra level imports
 */
//import czechMessages from '../framework/ratranslate/cz';
import englishMessages from 'ra-language-english';
import en_messages from './en_messages';
import lodashGet from 'lodash/get';
/**
 * CUSTOMIZE Resources used by this app
 */
import PeopleResources from "./people/PeopleResources";
import SiteResources from "./sites/SiteResources";
import StationResources from "./stations/StationResources";
import PressPalletBuilderResources from "./presspalletbuilder/PressPalletBuilderResources";

import polyglotI18nProvider from 'ra-i18n-polyglot';
import StationAdoptResources from "./stationadopt/StationAdoptResources";
import ReportTemplateResources from "./reporttemplates/ReportTemplateResources";
import UserResources from "./users/UserResources";
import SystemSettingsResources from "./systemsettings/SystemSettingsResources";

/**
 * Customize - App Level stuff
 */

/**
 * CUSTOMIZE  Custom component imports
 */



/**
 * CUSTOMIZE - i18n related
 */
const messages = {
//    cz: czechMessages,
    en: englishMessages,
}
_.merge(messages, {en: en_messages});





const menuItems = [];
var customRoutes = [];

/**
 * CUSTOMIZE Resources used by this app
 */
export var Resources = [
    //PalletManifestResources,
    // WorkstationSetupResources,
    UserResources,
    PeopleResources,
    SiteResources,
    ReportTemplateResources,
    StationResources,
    PressPalletBuilderResources,
    StationAdoptResources,
    SystemSettingsResources
];

/**
 * Do not change
 */
Resources.map(r => {
    _.merge(messages, r.messages);
});



/**
 * Do not change
 */
Resources.map(r => {
    if (r.customRoutes) {
        customRoutes = customRoutes.concat(r.customRoutes);
    }
});
console.log('custom routes', {customRoutes});



/**
 * CUSTOMIZE Add additional menu items, routes and messages here
 */
//menuItems.push({parent: 'releasepresets', name: 'activereleasepreset', route: 'activereleasepreset', icon: null});
//_.merge(messages, CustomAppAboutResources.messages);


/**
 * Do not change - Menu building
 */
Resources.map(r => {
    r.disabled || r.menuHidden ? console.log('disabled menu item ' + r.name) : menuItems.push(
        {parentMenu: r.parentMenu ? r.parentMenu : r.RESOURCE,
            parentMenuOrder: r.parentMenuOrder ? r.parentMenuOrder: 0,
            parentMenuIcon: r.parentMenuIcon,
            name: r.RESOURCE, icon: r.ICON,
            menuAuth: r.menuAuth
        })});

/**
 * Do not change - Custom menu building
 */
Resources.map(r => {
    if (r.customMenuItems) {
        r.customMenuItems.forEach((menu) => {
            menuItems.push(
                {
                    parentMenu: menu.parentMenu ? menu.parentMenu : menu.name,
                    parentMenuOrder: menu.parentMenuOrder ? menu.parentMenuOrder : 0,
                    parentMenuIcon: menu.parentMenuIcon,
                    name: menu.name, icon: menu.icon, route: menu.route, menuAuth: menu.menuAuth
                })
        });

    }
});



/**
 * Do not change - custom data providers
 */
Resources.map(r => {
    if (r.dataProvider) {
        registerProvider(r.RESOURCE, r.dataProvider);
    }
});


/**
 * CUSTOMIZE Add additional menu items, routes and messages here
 */
// _.merge(messages, CustomAppDashboardResources.messages);
//menuItems.push({name: 'about', icon: CustomAppAboutResources.ICON});
//customRoutes.push(<Route exact path="/about" component={CustomAppAboutResources.SHOW}/>);
// _.merge(messages, CustomAppAboutResources.messages);
//menuItems.push({name: 'about'});

/**
 * Custom non react-admin page, press checkin
 */



/**
 * CUSTOMIZE Theme related
 */
const purpleTheme = createMuiTheme({
    palette: {

        secondary: {
            main: '#9c27b0',
            light: '#d05ce3',
            dark: '#6a0080',
            contrastText: '#FFFFFF',
        },
        primary: {
            main: '#009688',
            light: '#CFD8DC',
            dark: '#455A64',
            contrastText: '#fff',
        },

    },
});

const greyTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#0277bd',
            light: '#58a5f0',
            dark: '#004c8c',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#546e7a',
            light: '#819ca9',
            dark: '#29434e',
            contrastText: '#fff',
        },
        shape: {
            borderRadius: 10,
        },
        overrides: {
            RaMenuItemLink: {
                root: {
                    borderLeft: '3px solid #fff',
                },
                active: {
                    borderLeft: '3px solid #546e7a',
                },
            },
            MuiPaper: {
                elevation1: {
                    boxShadow: 'none',
                },
                root: {
                    border: '1px solid #e0e0e3',
                    backgroundClip: 'padding-box',
                },
            },
            MuiButton: {
                contained: {
                    backgroundColor: '#fff',
                    color: '#4f3cc9',
                    boxShadow: 'none',
                },
            },
            MuiAppBar: {
                colorSecondary: {
                    color: '#808080',
                    backgroundColor: '#fff',
                },
            },
            MuiLinearProgress: {
                colorPrimary: {
                    backgroundColor: '#f5f5f5',
                },
                barColorPrimary: {
                    backgroundColor: '#d7d7d7',
                },
            },
            MuiFilledInput: {
                root: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    '&$disabled': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                },
            },
        },

    },
});

const theme = greyTheme;


/**
 * Customize title and title styles
 * @type {{container: {verticalAlign: string}}}
 */
const titleStyles = {
    container: {
        verticalAlign: 'middle'
    },
};

const Title = 'Infinity Production Tracker ';

/**
 * Do not change
 */
const i18nProvider = polyglotI18nProvider(locale => messages[locale], 'en');


export default ({
    apptitle: Title,
    theme: theme,
    menuItems: menuItems,
    RESOURCES: Resources,
    i18nProvider: i18nProvider,
    customRoutes: customRoutes,
    dataProvider: DataProviderFactory,
    authProvider: CustomAuthProvider,
    logo: null,
    globalState: {},
    dashboard: dashboard
});


